import { createSelector } from 'reselect'

const modal = (state, name) => state.modals[name]

export const getModalValue = createSelector([modal], modal => (modal ? modal.isActive : false))
